// frontend/src/pages/PickList.js
import React, { useState, useEffect } from 'react';
import { api, channelLabel } from '../App';
import ChannelStatusBar from '../components/ChannelStatusBar';

const CHANNEL_ICONS = { ebay_source: '🛒', ebay_store2: '🏪', walmart: '🟡', amazon: '📦', mercari: '🔵', poshmark: '🔴' };

function MobilePickList({ data, checked, toggle, doneCount, total, onRefresh }) {
  const [currentBinIdx, setCurrentBinIdx] = useState(0);
  const bins = data?.bins || [];
  const currentBin = bins[currentBinIdx];
  const allItems = currentBin?.items || [];

  return (
    <div style={{ fontFamily:'system-ui, -apple-system, sans-serif', background:'#0f1117', minHeight:'100vh', color:'#fff', maxWidth:500, margin:'0 auto' }}>

      {/* Header */}
      <div style={{ background:'#1a1d2e', borderBottom:'1px solid #2a2d3e', padding:'12px 16px', position:'sticky', top:0, zIndex:10 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div>
            <div style={{ fontSize:18, fontWeight:700 }}>📋 Pick List</div>
            <div style={{ fontSize:12, color:'#888', marginTop:1 }}>
              {new Date().toLocaleDateString('en-US', { weekday:'short', month:'short', day:'numeric' })}
            </div>
          </div>
          <button onClick={onRefresh} style={{ background:'rgba(108,99,255,.2)', border:'none', borderRadius:8, padding:'8px 14px', color:'#6c63ff', fontSize:14, cursor:'pointer', fontWeight:600 }}>
            🔄 Refresh
          </button>
        </div>

        {/* Progress bar */}
        <div style={{ marginTop:10 }}>
          <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4, fontSize:12, color:'#888' }}>
            <span>Progress</span>
            <span style={{ color:'#4ade80', fontWeight:700 }}>{doneCount}/{total} picked</span>
          </div>
          <div style={{ height:6, background:'#2a2d3e', borderRadius:99, overflow:'hidden' }}>
            <div style={{ height:'100%', width:`${total ? (doneCount/total)*100 : 0}%`, background:'#4ade80', borderRadius:99, transition:'width .3s' }} />
          </div>
        </div>
      </div>

      {total === 0 ? (
        <div style={{ textAlign:'center', padding:'60px 20px' }}>
          <div style={{ fontSize:64, marginBottom:16 }}>✅</div>
          <div style={{ fontSize:20, fontWeight:700 }}>All done!</div>
          <div style={{ fontSize:14, color:'#888', marginTop:8 }}>No pending orders</div>
        </div>
      ) : (
        <>
          {/* Bin tabs */}
          <div style={{ display:'flex', gap:6, padding:'10px 12px', overflowX:'auto', background:'#1a1d2e' }}>
            {bins.map((bin, idx) => {
              const binDone = bin.items.filter(i => checked[i.id]).length;
              const binTotal = bin.items.length;
              const allDone = binDone === binTotal;
              return (
                <button key={bin.location} onClick={() => setCurrentBinIdx(idx)}
                  style={{ flexShrink:0, padding:'6px 14px', borderRadius:20, border:'none', cursor:'pointer', fontSize:13, fontWeight:600,
                    background: idx === currentBinIdx ? '#6c63ff' : allDone ? 'rgba(74,222,128,.2)' : '#2a2d3e',
                    color: idx === currentBinIdx ? '#fff' : allDone ? '#4ade80' : '#aaa' }}>
                  {bin.location} {allDone ? '✓' : `${binDone}/${binTotal}`}
                </button>
              );
            })}
          </div>

          {/* Current bin */}
          {currentBin && (
            <div style={{ padding:'12px' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                <div style={{ fontSize:22, fontWeight:800, letterSpacing:'.02em' }}>
                  📦 {currentBin.location}
                </div>
                <div style={{ fontSize:13, color:'#888' }}>
                  {allItems.filter(i => !checked[i.id]).length} remaining
                </div>
              </div>

              {allItems.map(item => {
                const done = !!checked[item.id];
                return (
                <div key={item.id} style={{ background: done ? 'rgba(74,222,128,.05)' : '#1a1d2e', borderRadius:14, padding:'16px', marginBottom:10,
                  border: done ? '1px solid rgba(74,222,128,.2)' : '1px solid #2a2d3e', opacity: done ? 0.55 : 1, transition:'opacity .3s' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:8 }}>
                    <div style={{ fontFamily:'monospace', fontSize:13, color: done ? '#4ade80' : '#6c63ff', fontWeight:700,
                      textDecoration: done ? 'line-through' : 'none' }}>{item.sku}</div>
                    <div style={{ fontSize:12, color:'#888' }}>{CHANNEL_ICONS[item.channel]}</div>
                  </div>
                  <div style={{ fontSize:16, fontWeight:600, lineHeight:1.3, marginBottom:10, color: done ? '#888' : '#fff',
                    textDecoration: done ? 'line-through' : 'none' }}>{item.title || '—'}</div>
                  <div style={{ display:'flex', gap:12, marginBottom:14, flexWrap:'wrap' }}>
                    <span style={{
                      background: item.quantity_sold > 1 ? 'rgba(251,191,36,.22)' : 'rgba(108,99,255,.2)',
                      color:      item.quantity_sold > 1 ? '#fbbf24' : '#6c63ff',
                      padding:'4px 12px', borderRadius:8, fontSize:14, fontWeight:700 }}>
                      Qty: {item.quantity_sold}
                    </span>
                    {item.combinable_count > 0 && (
                      <span title="Same buyer has other open orders — may ship together"
                        style={{ background:'rgba(251,191,36,.22)', color:'#fbbf24',
                          padding:'4px 12px', borderRadius:8, fontSize:13, fontWeight:700 }}>
                        Combine +{item.combinable_count}
                      </span>
                    )}
                    {item.stock_qty != null && (
                      <span style={{ background: (item.stock_qty - item.quantity_sold) <= 0 ? 'rgba(239,68,68,.2)' : 'rgba(255,255,255,.05)',
                        color: (item.stock_qty - item.quantity_sold) <= 0 ? '#ef4444' : '#888',
                        padding:'4px 12px', borderRadius:8, fontSize:13 }}>
                        After: {Math.max(0, item.stock_qty - item.quantity_sold)} left
                      </span>
                    )}
                    {item.ship_by_date && (
                      <span style={{ background: isUrgent(item.ship_by_date) ? 'rgba(239,68,68,.2)' : 'rgba(255,255,255,.05)',
                        color: isUrgent(item.ship_by_date) ? '#ef4444' : '#888',
                        padding:'4px 12px', borderRadius:8, fontSize:13 }}>
                        Ship by {new Date(item.ship_by_date).toLocaleDateString('en-US', { month:'short', day:'numeric' })}
                      </span>
                    )}
                  </div>
                  <div style={{ fontSize:11, color:'#555', marginBottom:12, fontFamily:'monospace' }}>
                    {item.buyer_name} · {item.platform_order_id}
                  </div>
                  <button onClick={() => toggle(item.id)}
                    style={{ width:'100%', padding:'16px', background: done ? 'transparent' : '#6c63ff',
                      border: done ? '1px solid #444' : 'none', borderRadius:12, color: done ? '#888' : '#fff',
                      fontSize:18, fontWeight:700, cursor:'pointer', letterSpacing:'.02em', display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
                    {done ? 'Undo Pick' : '✓ Mark Picked'}
                  </button>
                </div>
                );
              })}

              {/* Navigation between bins */}
              <div style={{ display:'flex', gap:8, marginTop:16 }}>
                <button disabled={currentBinIdx === 0} onClick={() => setCurrentBinIdx(i => i-1)}
                  style={{ flex:1, padding:'14px', background:'#2a2d3e', border:'none', borderRadius:12, color: currentBinIdx === 0 ? '#444' : '#fff',
                    fontSize:15, fontWeight:600, cursor: currentBinIdx === 0 ? 'default' : 'pointer' }}>
                  ← Prev Bin
                </button>
                <button disabled={currentBinIdx === bins.length - 1} onClick={() => setCurrentBinIdx(i => i+1)}
                  style={{ flex:1, padding:'14px', background: currentBinIdx === bins.length - 1 ? '#2a2d3e' : '#6c63ff',
                    border:'none', borderRadius:12, color: currentBinIdx === bins.length - 1 ? '#444' : '#fff',
                    fontSize:15, fontWeight:600, cursor: currentBinIdx === bins.length - 1 ? 'default' : 'pointer' }}>
                  Next Bin →
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default function PickList() {
  const [data, setData]       = useState(null);
  const [checked, setChecked] = useState({});
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [syncing, setSyncing] = useState(false);

  function load() {
    setLoading(true);
    api.get('/picklist').then(r => {
      setData(r.data);
      // Pre-populate checked state from already-picked orders
      const alreadyPicked = {};
      r.data.bins?.forEach(bin => bin.items.forEach(item => {
        if (item.order_status === 'picked') alreadyPicked[item.id] = true;
      }));
      setChecked(alreadyPicked);
      setLoading(false);
    });
  }

  async function syncAndRefresh() {
    setSyncing(true);
    try { await api.post('/sync/orders'); } catch {}
    load();
    setSyncing(false);
  }

  useEffect(() => { load(); }, []);

  function toggle(orderId) {
    const newVal = !checked[orderId];
    setChecked(prev => ({ ...prev, [orderId]: newVal }));
    api.patch(`/orders/${orderId}/status`, { status: newVal ? 'picked' : 'pending' }).catch(() => {});
  }

  const doneCount = Object.values(checked).filter(Boolean).length;
  const total     = data?.total_orders || 0;

  if (loading) return <div className="loading">Loading pick list…</div>;

  // Mobile view
  if (isMobile) {
    return <MobilePickList data={data} checked={checked} toggle={toggle} doneCount={doneCount} total={total} onRefresh={load} />;
  }

  // Desktop view
  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">📋 Morning Pick List</div>
          <div style={{ fontSize:12, color:'var(--muted)', marginTop:2 }}>
            {new Date().toLocaleDateString('en-US', { weekday:'long', month:'long', day:'numeric' })}
          </div>
        </div>
        <div style={{ display:'flex', gap:8 }}>
          <button className="btn btn-ghost" onClick={() => window.open('/api/picklist/pdf', '_blank')}>⬇️ PDF</button>
          <button className="btn btn-ghost" onClick={() => window.open('/pick', '_blank')}>📱 Mobile</button>
          <button className="btn btn-primary" onClick={syncAndRefresh} disabled={syncing}>
            {syncing ? '⏳ Syncing…' : '🔄 Sync & Refresh'}
          </button>
        </div>
      </div>

      <div className="card" style={{ padding:'12px 16px' }}>
        <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8 }}>
          <span style={{ fontWeight:700 }}>Progress</span>
          <span style={{ color:'var(--accent2)', fontWeight:700 }}>{doneCount} / {total} picked</span>
        </div>
        <div style={{ height:8, background:'var(--border)', borderRadius:99, overflow:'hidden' }}>
          <div style={{ height:'100%', width:`${total ? (doneCount/total)*100 : 0}%`, background:'var(--accent2)', borderRadius:99, transition:'width .3s' }} />
        </div>
      </div>

      {total === 0 ? (
        <div className="empty-state"><div className="empty-icon">✅</div><div>No pending orders!</div></div>
      ) : (
        data.bins.map(({ location, items }) => (
          <div key={location} className="bin-section">
            <div className="bin-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span>📦 {location}</span>
              <span style={{ fontSize:12, fontWeight:400, color:'var(--muted)' }}>
                {items.length} order{items.length !== 1 ? 's' : ''}
              </span>
            </div>
            {items.map(item => (
              <div key={item.id} className={`pick-item ${checked[item.id] ? 'done' : ''}`}>
                <input type="checkbox" className="pick-check" checked={!!checked[item.id]} onChange={() => toggle(item.id)} />
                <div className="pick-info">
                  <div style={{ display:'flex', justifyContent:'space-between' }}>
                    <div className="pick-sku">{item.sku}</div>
                    <div style={{ fontSize:11, color:'var(--muted)' }}>{CHANNEL_ICONS[item.channel]} {channelLabel(item.channel)}</div>
                  </div>
                  <div className="pick-title">{item.title || '—'}</div>
                  <div className="pick-meta">
                    <strong style={{ fontSize:14, color: item.quantity_sold > 1 ? '#fbbf24' : 'var(--accent2)' }}>Qty: {item.quantity_sold}</strong>
                    {item.stock_qty != null && (
                      <span style={{ marginLeft:8, fontSize:12, color:'var(--muted)' }}>
                        · Remaining after: <strong style={{ color: (item.stock_qty - item.quantity_sold) <= 0 ? 'var(--danger)' : (item.stock_qty - item.quantity_sold) === 1 ? 'var(--warn)' : 'var(--text)' }}>{Math.max(0, item.stock_qty - item.quantity_sold)}</strong>
                      </span>
                    )}
                    {item.buyer_name && <> · {item.buyer_name}</>}
                    {item.combinable_count > 0 && (
                      <span title="Same buyer has other open orders — may ship together"
                        style={{ marginLeft:6, fontSize:11, padding:'2px 8px', borderRadius:4, fontWeight:700,
                          background:'rgba(251,191,36,.18)', color:'#fbbf24' }}>
                        Combine +{item.combinable_count}
                      </span>
                    )}
                    {item.ship_by_date && <> · Ship by: <strong style={{ color:isUrgent(item.ship_by_date) ? 'var(--danger)' : 'inherit' }}>{new Date(item.ship_by_date).toLocaleDateString()}</strong></>}
                  </div>
                  <div style={{ fontSize:11, fontFamily:'monospace', color:'var(--muted)', marginTop:2 }}>Order: {item.platform_order_id}</div>
                </div>
              </div>
            ))}
          </div>
        ))
      )}
      <div style={{ height: 44 }} />
      <ChannelStatusBar />
    </div>
  );
}

function isUrgent(d) { return d && new Date(d) <= new Date(Date.now() + 86400000); }
